import {
  styled,
  TextTag,
  TokenTextAppearance,
  Text,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';

const StyledErrorWrapper = styled.div`
  display: grid;
  gap: ${(props) => props.theme.size.dynamic0100};
  justify-self: center;
  width: ${(props) => `clamp(15rem, ${props.theme.size.grid012}, 30rem)`};

  & button {
    justify-self: center;
    align-self: center;
  }
`;

interface ErrorPageProps {
  message: string;
}

export const ErrorPage = (props: ErrorPageProps): JSX.Element => {
  const {message} = props;

  return (
    <StyledErrorWrapper>
      <Text tag={TextTag.h1} appearance={TokenTextAppearance.headline400} bold>
        Things did not workout as expected
      </Text>
      <Text tag={TextTag.p}>
        This page didn’t load due to data missing or some other horrible error
        just occurred. You broke it or we broke it. Sometimes it just happens.
      </Text>
      <Text tag={TextTag.p}>(This is likely what happened: {message})</Text>
    </StyledErrorWrapper>
  );
};
